import { useState } from "react";
import api, { formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { RotateCw } from "lucide-react";
import { toast } from "sonner";
import { orderEmailSummary, toastOrderEmailResult } from "@/lib/orderEmail";

const TONE = {
  sent: "bg-emerald-50 text-emerald-700 border-emerald-200",
  queued: "bg-amber-50 text-amber-700 border-amber-200",
  pending: "bg-blue-50 text-blue-700 border-blue-200",
  failed: "bg-red-50 text-red-700 border-red-200",
  skipped: "bg-slate-50 text-slate-600 border-slate-200",
};

// Result of the automatic "order raised" email (email_status & co. on the
// order), with a "Resend email" button when it failed. `resendPath` is the
// POST endpoint; `onDone` reloads the page's data afterwards.
export default function OrderEmailStatus({ order, resendPath, label, myEmail, onDone, testid = "order-email-status" }) {
  const [busy, setBusy] = useState(false);
  if (!order?.email_status) return null;
  const summary = orderEmailSummary(order, myEmail);
  const resend = async () => {
    setBusy(true);
    try {
      const { data } = await api.post(resendPath);
      toastOrderEmailResult(label, data, myEmail);
      await onDone?.();
    } catch (e) {
      toast.error(formatApiError(e.response?.data?.detail) || "Resend failed");
    } finally {
      setBusy(false);
    }
  };
  return (
    <span className="inline-flex items-center gap-1.5" data-testid={testid}>
      <span
        className={`text-[11px] px-2 py-0.5 rounded-full border max-w-[22rem] truncate ${TONE[order.email_status] || TONE.skipped}`}
        title={[summary, order.email_warning].filter(Boolean).join(" — ")}
      >
        {summary}
      </span>
      {order.email_status === "failed" && (
        <Button variant="outline" size="sm" onClick={resend} disabled={busy}
          className="text-red-700 border-red-300 hover:bg-red-50" data-testid={`${testid}-resend`}>
          <RotateCw className={`w-4 h-4 mr-1.5 ${busy ? "animate-spin" : ""}`} />Resend email
        </Button>
      )}
    </span>
  );
}
